import React, {useEffect, useState} from 'react';
import AppHeader from '../../../components/Dashboard/AppHeader';
import {Content} from 'antd/es/layout/layout';
import {Spin, Card, Row, Col, Empty, Tag, Typography, Space, Button} from 'antd';
import {
	UserOutlined,
	MailOutlined,
	ReadOutlined,
	LoadingOutlined,
	FilePdfOutlined,
} from '@ant-design/icons';
import userStore from '../../../zustand/store/userStore';
import {
	getEnrolledCoursesAPI,
	getSubjectLecturesAPI,
} from '../../../zustand/API';
import useStudentLectureStore from '../../../zustand/store/useStudentLectureStore';
import {useNavigate} from 'react-router';

const {Title, Text} = Typography;

const EnrollCourses = () => {
	const {user} = userStore();
	const {fetchLectures, lectures} = useStudentLectureStore();
	const navigate = useNavigate();
	const [courses, setCourses] = useState([]);
	const [loading, setLoading] = useState(true);

	const fetchCourses = async () => {
		const data = await getEnrolledCoursesAPI(user?.email);
		setCourses(data);
		setLoading(false);
	};

	useEffect(() => {
		fetchCourses();
	}, []);

	const handleClick = async ({
		className,
		subject,
		teacherEmail,
		teacherName,
	}) => {
		navigate('/view-lectures');
		await fetchLectures({
			className,
			subject,
			teacherEmail,
			teacherName,
			studentEmail: user?.email,
		});
	};

	return (
		<Content className="p-2 min-h-screen">
			<AppHeader
				title={'🎓 Enrolled Courses'}
				content={
					'Explore the list of all courses you are currently enrolled in.'
				}
			/>

			{loading ? (
				<div className="text-center mt-20">
					<Spin
						size="large"
						indicator={
							<LoadingOutlined style={{fontSize: 36, color: '#22C55E'}} spin />
						}
						tip="Fetching your courses..."
					/>
				</div>
			) : courses?.length === 0 ? (
				<Empty description="No enrolled courses found." className="mt-10" />
			) : (
				<Row gutter={[20, 20]} className="mt-6">
					{courses.map((course) => (
						<Col xs={24} sm={12} md={8} key={course._id}>
							<Card
								className="cursor-pointer rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 border border-gray-200"
								bodyStyle={{padding: '20px'}}
								onClick={() => handleClick(course)}
							>
								<Space direction="vertical" size="small">
									<Title
										level={5}
										className="flex items-center gap-2 !mb-2 text-[#3B82F6]"
									>
										<ReadOutlined />
										{course.subject}
									</Title>

									<Tag
										color="green"
										className="w-fit rounded-full px-3 py-1 text-sm"
									>
										Class: {course.className}
									</Tag>

									<Tag
										color="blue"
										icon={<FilePdfOutlined />}
										className="w-fit rounded-full px-3 py-1 text-sm"
									>
										{course.lectureCount} Lecture
										{course.lectureCount > 1 ? 's' : ''}
									</Tag>

									<Text className="text-gray-600">
										<UserOutlined className="mr-2 text-[#10B981]" />
										<strong>Teacher:</strong> {course.teacherName}
									</Text>

									<Text className="text-gray-600">
										<MailOutlined className="mr-2 text-[#F97316]" />
										<strong>Email:</strong> {course.teacherEmail}
									</Text>
									{/* <Button
										type="primary"
										className="mt-2 bg-blue-500"
										onClick={(e) => {
											e.stopPropagation();
											navigate('/messages', {
												state: {
													receiverEmail: course.teacherEmail,
													senderEmail: user?.email,
												},
											});
										}}
									>
										Message
									</Button> */}
								</Space>
							</Card>
						</Col>
					))}
				</Row>
			)}
		</Content>
	);
};

export default EnrollCourses;
